import orgData from "~/config/organization.json";
import generalData from "~/config/general.json";

export const useGlobyConfig = () => {
    return {
        organization: orgData,
        general: generalData,
    };
};
